import { render, staticRenderFns } from "./Wp_robot_public_on_off_model.vue?vue&type=template&id=c16876cc&scoped=true&"
import script from "./Wp_robot_public_on_off_model.vue?vue&type=script&lang=js&"
export * from "./Wp_robot_public_on_off_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16876cc",
  null
  
)

export default component.exports